var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 650,
    viewBox: "0 0 650 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M672.344 -87.75L-102.781 -65L-26.4062 690.625L665.844 724.75L699.674 320.981L672.344 -87.75Z",
    fill: "#D90267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-170.625 412.75L-39 264.875L1096.47 20.2841L34.125 -95.875L-170.625 412.75Z",
    fill: "#F9D877"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.656 540.719H66.2188C63.9754 540.719 62.1562 538.9 62.1562 536.656V115.781C62.1562 113.538 63.9754 111.719 66.2188 111.719H575.656C577.9 111.719 579.719 113.538 579.719 115.781V536.656C579.719 538.9 577.9 540.719 575.656 540.719Z",
    fill: "#463AEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.656 540.719H66.2188C63.9754 540.719 62.1562 538.9 62.1562 536.656V115.781C62.1562 113.538 63.9754 111.719 66.2188 111.719H575.656C577.9 111.719 579.719 113.538 579.719 115.781V536.656C579.719 538.9 577.9 540.719 575.656 540.719Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.281 171.438C564.281 192.303 547.367 209.219 526.5 209.219C505.633 209.219 488.719 192.303 488.719 171.438C488.719 150.572 505.633 133.656 526.5 133.656C547.367 133.656 564.281 150.572 564.281 171.438Z",
    fill: "#00CC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.281 171.438C564.281 192.303 547.367 209.219 526.5 209.219C505.633 209.219 488.719 192.303 488.719 171.438C488.719 150.572 505.633 133.656 526.5 133.656C547.367 133.656 564.281 150.572 564.281 171.438Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.074 269.653H538.244L534.837 279.652H532.863L529.482 269.653H531.712L533.883 277.243L536.074 269.653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.344 290.47H557.781",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.75 392.845H558.188",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.75 290.47V392.845",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.186 278.764C546.432 279.541 545.339 279.931 543.911 279.931C542.482 279.931 541.39 279.541 540.635 278.764C539.622 277.81 539.116 276.434 539.116 274.639C539.116 272.808 539.622 271.434 540.635 270.516C541.39 269.739 542.482 269.349 543.911 269.349C545.339 269.349 546.432 269.739 547.186 270.516C548.195 271.434 548.7 272.808 548.7 274.639C548.7 276.434 548.195 277.81 547.186 278.764ZM545.881 277.244C546.367 276.633 546.61 275.765 546.61 274.639C546.61 273.518 546.367 272.651 545.881 272.038C545.395 271.425 544.738 271.12 543.911 271.12C543.084 271.12 542.423 271.425 541.93 272.036C541.437 272.646 541.192 273.513 541.192 274.639C541.192 275.765 541.437 276.633 541.93 277.244C542.423 277.854 543.084 278.159 543.911 278.159C544.738 278.159 545.395 277.854 545.881 277.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.295 269.653H552.382V277.854H557.375V279.652H550.295V269.653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 311.188C531.88 311.188 530.969 310.277 530.969 309.156V302.25C530.969 301.13 531.88 300.219 533 300.219H553.312C554.433 300.219 555.344 301.13 555.344 302.25V309.156C555.344 310.277 554.433 311.188 553.312 311.188H533Z",
    fill: "#00CC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.312 309.156H533V302.25H553.312V309.156ZM553.312 298.188H533C530.756 298.188 528.938 300.006 528.938 302.25V309.156C528.938 311.4 530.756 313.219 533 313.219H553.312C555.557 313.219 557.375 311.4 557.375 309.156V302.25C557.375 300.006 555.557 298.188 553.312 298.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 497.25C456.8 497.25 447.688 488.138 447.688 476.938C447.688 465.737 456.8 456.625 468 456.625C479.2 456.625 488.313 465.737 488.313 476.938C488.313 488.138 479.2 497.25 468 497.25Z",
    fill: "#00CC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 458.656C478.08 458.656 486.281 466.858 486.281 476.938C486.281 487.017 478.08 495.219 468 495.219C457.92 495.219 449.719 487.017 449.719 476.938C449.719 466.858 457.92 458.656 468 458.656ZM468 454.594C455.66 454.594 445.656 464.598 445.656 476.938C445.656 489.278 455.66 499.281 468 499.281C480.34 499.281 490.344 489.278 490.344 476.938C490.344 464.598 480.34 454.594 468 454.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.594 457.031V476.531",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.353 495.347C510.202 490.613 505.795 478.504 510.528 468.353C515.262 458.202 527.371 453.795 537.522 458.528C547.673 463.262 552.08 475.371 547.347 485.522C542.613 495.673 530.504 500.08 520.353 495.347Z",
    fill: "#00CC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.663 460.369C545.799 464.629 549.766 475.528 545.506 484.663C541.246 493.799 530.347 497.766 521.212 493.506C512.076 489.246 508.109 478.347 512.369 469.211C516.629 460.076 527.528 456.109 536.663 460.369ZM538.38 456.687C527.196 451.472 513.902 456.311 508.687 467.495C503.472 478.679 508.311 491.973 519.495 497.188C530.679 502.403 543.973 497.564 549.188 486.38C554.403 475.197 549.564 461.902 538.38 456.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.982 458.725L528.741 476.398",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5448 228.056C129.595 133.457 242.804 93.2896 337.403 138.34C432.002 183.39 472.17 296.6 427.119 391.199C382.069 485.798 268.86 525.965 174.261 480.915C79.6618 435.864 39.4944 322.655 84.5448 228.056Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.733 366.727C356.422 407.278 319.219 433.541 278.073 440.566",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.619 277.54C203.852 239.255 249.669 222.999 287.954 241.231C326.24 259.464 342.496 305.28 324.263 343.566C306.031 381.851 260.214 398.107 221.929 379.875C183.643 361.642 167.387 315.826 185.619 277.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.606 307.06C249.535 303.008 254.383 301.288 258.435 303.217C262.486 305.147 264.206 309.995 262.277 314.046C260.348 318.098 255.499 319.818 251.448 317.889C247.396 315.959 245.676 311.111 247.606 307.06Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.096 183.588C246.059 173.768 280.674 175.217 312.315 190.285",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.692 107.224L357.672 396.222",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.78 395.41L355.196 383.69C353.402 382.341 353.042 379.794 354.39 378.001L366.843 361.443C368.192 359.65 370.739 359.289 372.531 360.638L388.116 372.358C389.91 373.706 390.27 376.254 388.922 378.047L376.468 394.606C375.12 396.398 372.574 396.759 370.78 395.41Z",
    fill: "#00CC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.78 395.41L355.196 383.69C353.402 382.341 353.042 379.794 354.39 378.001L366.843 361.443C368.192 359.65 370.739 359.289 372.531 360.638L388.116 372.358C389.91 373.706 390.27 376.254 388.922 378.047L376.468 394.606C375.12 396.398 372.574 396.759 370.78 395.41Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 650,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.a4f3672e60a7247e4e086a9756467136.svg";
export { ForwardRef as ReactComponent };